<template>
  <v-card>
    <div class="flex-grow-1 px-2">
      <div class="title-bar d-flex justify-space-between">
        <div>
          <div class="title">
            {{certificate.name}}
          </div>
        </div>
        <div class="actions" :class="{'small': certificate.is_active}">
          <ButtonActionEdit @click="$emit('edit')" />
          <ButtonActionDelete @click="$emit('delete')" v-if="!certificate.is_active" />
        </div>
      </div>
      <v-card-text>
        <v-row>
          <div class="user-card-label">
            Datoteka:
          </div>
          <div class="user-card-value">
            {{certificate.filename}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label">
            Veljavno do:
          </div>
          <div class="user-card-value">
            {{certificate.valid_to | sloDate}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label">
            Aktiviran:
          </div>
          <div class="user-card-value">
            <ActiveIcon :value="certificate.is_active" />
            <v-btn
              class="float-right"
              color="#0F998E"
              dark
              small
              @click="toggleActive"
            >
              {{certificate.is_active ? 'Deaktiviraj' : 'Aktiviraj'}}
            </v-btn>
          </div>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import ButtonActionEdit from './ButtonActionEdit'
import ButtonActionDelete from './ButtonActionDelete'
import ActiveIcon from './ActiveIcon'
import { mapActions } from 'vuex'

export default {
  components: {
    ButtonActionEdit,
    ButtonActionDelete,
    ActiveIcon
  },
  props: {
    certificate: {
      required: true,
      type: Object
    },
    childCompanyId: {
      required: true,
      type: Number
    }
  },
  computed: {
  },
  methods: {
    ...mapActions('clientsCertificates', ['setActive']),
    toggleActive () {
      this.setActive({ childCompanyId: this.childCompanyId, certificateId: this.certificate.id, active: !this.certificate.is_active })
        .then(cert => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-card {
    padding: 20px;
  }
  .title-bar {
    padding: 10px;
    padding-bottom: 20px;
    box-shadow: 0 4px 3px -5px #455A64;

    .title {
      font-size: 22px;
      font-weight: bold;
      color: #607D8B;
    }
    .subtitle {
      color: #B0BEC5;
      font-size: 12px;
    }
    .actions {
      min-width: 60px;
      max-width: 60px;
      margin-left: 15px;
      &.small {
        min-width: 30px;
        max-width: 30px;
      }
    }
  }
  .v-card__text {
    .col {
      padding: 6px 12px;
    }
    .user-card-label {
      min-width: 120px;
      color: #BDBDBD;
    }
    .user-card-value {
      min-width: 160px;
      color: #607D8B;
      font-weight: bold;
    }
  }
</style>
